export default __webpack_public_path__ + "static/media/chevronDown.182d1c70.svg";